import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { getI18n, useTranslation } from 'react-i18next'
import { ISkillFormPackage } from '../../interfaces/skills/ISkills'
import { useStore } from '../../Provider'
import { OPLoadMore } from '../OPcomponents/OPLoadMore'
import { Data, OPNewTable } from '../OPcomponents/OPNewTable'
import OpenSkill from './OpenSkill'

const SkillsTable = (): JSX.Element => {
  const rootStore = useStore()
  const { t } = useTranslation()
  const { filteredSkills, allSkills, getUserDetailedSkillLinkedProjects, getAllSkills } = rootStore.skillStore
  const { getAllUserSkills } = rootStore.personStore
  const { getSkillPersons } = rootStore.seachStore
  const { validatedUser } = rootStore.loginStore
  const [tableLength, setTableLength] = useState(50)

  const [tableRows, setTableRows] = useState<Data[]>([])

  const openSkillRow = async (id: number | string) => {
    const curClicked = allSkills.find((skill) => skill.skill.skillId === Number(id))
    const userSkill = await getUserDetailedSkillLinkedProjects(validatedUser, Number(id))
    const skillPersons = await getSkillPersons(Number(id))

    if (curClicked?.skill) {
      const skillInfo: ISkillFormPackage = {
        skill: { skill: curClicked.skill, userInterested: curClicked.userInterested },
        userSkill: userSkill.skill,
        isNew: userSkill.isNew,
        skillPersons: skillPersons,
      }
      return skillInfo
    }
  }

  const onRowClose = () => {
    Promise.allSettled([getAllSkills(validatedUser, false), getAllUserSkills(validatedUser, false)])
  }

  useEffect(() => {
    const newRows: Data[] = []
    const lang = getI18n().language
    // Build a map for O(1) metadata lookups
    const skillMetaMap = new Map(allSkills.map((s) => [s.skill.skillId, s.skill]))

    filteredSkills.map((skill) => {
      const meta = skillMetaMap.get(skill.skill.skillId)
      const parentId = meta?.parentSkillId ?? null
      const parent = parentId ? skillMetaMap.get(parentId) : undefined
      const parentName = parent ? (lang === 'en' && parent.skillNameEng?.length ? parent.skillNameEng : parent.skillNameFi) : ''

      const displayName = lang === 'en' && skill.skill.skillNameEng?.length ? skill.skill.skillNameEng : skill.skill.skillNameFi
      const categoryName = lang === 'en' && skill.skill.categoryNameEng?.length ? skill.skill.categoryNameEng : skill.skill.categoryName
      newRows.push({
        ['id']: skill.skill.skillId,
        rows: {
          [t('Skills.SkillName')]: {
            text: displayName,
            width: '30%',
          },
          [t('Skills.Category')]: { text: categoryName ?? '', width: '30%' },
          [t('Skills.ParentSkill')]: {
            text: parentName || t('Projects.NotDefined'),
            width: '30%',
          },
          [t('Skills.Experts')]: { text: skill.skill.osaajat ?? 0, width: '5%', align: 'right' as const },
        },
      })
      setTableRows(newRows)
    })
  }, [t, filteredSkills, allSkills])
  return filteredSkills.length ? (
    <>
      <OPNewTable rows={tableRows} curLength={tableLength} onRowClose={onRowClose} FormBase={OpenSkill} onRowClick={openSkillRow} />
      <OPLoadMore
        stepper={50}
        filteredArray={filteredSkills}
        onLoadMore={(data) => setTableLength(data)}
        curLength={tableLength}
        maxLength={filteredSkills.length}
      />
    </>
  ) : (
    <span className='profile--notfound'>{t('NotFound.NoResults')}</span>
  )
}

export default observer(SkillsTable)
